import {
  ArrowIconWrapper,
  HiveBodyChartAdditionalContent,
  HiveBodyChartNoContent,
  HiveBodyChartTitleRow,
  HiveBodyChartWrapper,
  LastUpdatedWrapper,
} from 'features/hive/ui/HiveBody/styles.ts';
import {FC, ReactNode, useCallback} from 'react';
import {chartValue} from 'widgets/chart/model/types.ts';
import {ArrowRight} from 'shared/ui/icons/arrowRight.tsx';
import {useNavigate} from 'react-router-dom';
import {DefaultChartWidget} from 'widgets/chart';

type AvgItem = {
  value: number | string;
  unit: string;
  status?: 'red' | 'yellow' | 'green';
};

export type HiveBodyChartProps = {
  icon: ReactNode;
  title: string;
  lastUpdatedTime?: string;
  to?: string | null;
  data: chartValue[];
  additionalInfo?: ReactNode;
  type: 'sparkline' | 'column';
  tooltipText: {title: string; dim: string; isSign: boolean}[];
  seriesLabel?: string;
  showDiff?: boolean;
  averages?: AvgItem[];
};

const HiveBodyChart: FC<HiveBodyChartProps> = ({
  icon,
  title,
  lastUpdatedTime,
  to,
  type,
  data,
  tooltipText,
  seriesLabel = '',
  showDiff = false,
  averages = [],
}) => {
  const navigate = useNavigate();
  const isActive = data.length > 0;
  const sparklineCurrentDate = type === 'sparkline' ? Date.now() : undefined;

  const onClick = useCallback(() => {
    if (to) navigate(to);
  }, [navigate, to]);

  const AveragesRow =
    averages.length > 0 ? (
      <div
        style={{
          display: 'grid',
          gridAutoFlow: 'column',
          gap: 16,
          justifyContent: 'flex-start',
          alignItems: 'baseline',
        }}
      >
        {averages.map((a, i) => (
          <div key={`avg-${i}`} style={{display: 'flex', alignItems: 'baseline', gap: 4}}>
            <span style={{fontWeight: 700}}>{a.value}</span>
            <span style={{opacity: 0.7}}>{a.unit}</span>
          </div>
        ))}
      </div>
    ) : null;

  const ChartWidget =
    type === 'sparkline' ? (
      <DefaultChartWidget
        isActive={isActive}
        type="sparkline"
        thresholds={[]}
        width="100%"
        height={100}
        data={data}
        seriesLabel={seriesLabel}
        fillFuture
        showAxes={false}
        periodForFill="day"
        currentDate={sparklineCurrentDate}
        tooltipText={tooltipText}
      />
    ) : (
      <DefaultChartWidget
        isActive={isActive}
        thresholds={[]}
        type="column"
        showAxes={false}
        width="100%"
        height={100}
        data={data}
        seriesLabel={seriesLabel}
        fillFuture
        periodForFill="day"
        showDiff={showDiff}
        tooltipText={tooltipText}
      />
    );

  return (
    <HiveBodyChartWrapper onClick={onClick} $active={!!to}>
      <HiveBodyChartTitleRow>
        {icon}
        <h4>{title}</h4>
        {lastUpdatedTime && <LastUpdatedWrapper>{lastUpdatedTime}</LastUpdatedWrapper>}
        <ArrowIconWrapper>
          <ArrowRight />
        </ArrowIconWrapper>
      </HiveBodyChartTitleRow>

      {isActive ? (
        <HiveBodyChartAdditionalContent>{AveragesRow}</HiveBodyChartAdditionalContent>
      ) : averages.length ? (
        <HiveBodyChartNoContent>{AveragesRow}</HiveBodyChartNoContent>
      ) : (
        <HiveBodyChartNoContent>Нет данных</HiveBodyChartNoContent>
      )}

      {ChartWidget}
    </HiveBodyChartWrapper>
  );
};

export default HiveBodyChart;
